'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useState, ReactNode, Suspense } from 'react';
interface SessionStateValue {
  sessionHash: string;
  // You can add more fields later if needed
  [key: string]: any;
}
const SessionStateContext = createContext<SessionStateValue | undefined>(undefined);
export function SessionStateProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [sessionHash] = useState(_temp);
  let t1;
  if ($[0] !== sessionHash) {
    t1 = {
      sessionHash
    };
    $[0] = sessionHash;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const value = t1;
  let t2;
  if ($[2] !== children || $[3] !== value) {
    t2 = <SessionStateContext.Provider value={value}>{children}</SessionStateContext.Provider>;
    $[2] = children;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}

// Hook to access the global session state
function _temp() {
  return crypto.randomUUID();
}
export function useSessionState() {
  const context = useContext(SessionStateContext);
  if (!context) {
    throw new Error("useSessionState must be used within a SessionStateProvider");
  }
  return context;
}